var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOriginal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "11px",
    viewBox: "0 0 17 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ImajBoyutu-Orjinal") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KIT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elementler-KIT",
    transform: "translate(-384.000000, -2914.000000)",
    fill: "#464646",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388.956055,2923.99414 L388.956055,2914 L387.219727,2914 L384,2916.56348 L385.018555,2917.83496 L386.166992,2916.91211 C386.303711,2916.80273 386.547526,2916.57259 386.898438,2916.22168 L386.898438,2916.22168 L386.864258,2917.26074 L386.84375,2918.21094 L386.84375,2923.99414 L388.956055,2923.99414 Z M393.166992,2918.53223 C393.536133,2918.53223 393.82666,2918.43083 394.038574,2918.22803 C394.250488,2918.02523 394.356445,2917.73926 394.356445,2917.37012 C394.356445,2916.99642 394.252767,2916.70931 394.04541,2916.50879 C393.838053,2916.30827 393.545247,2916.20801 393.166992,2916.20801 C392.775065,2916.20801 392.476562,2916.30599 392.271484,2916.50195 C392.066406,2916.69792 391.963867,2916.9873 391.963867,2917.37012 C391.963867,2917.74382 392.068685,2918.03092 392.27832,2918.23145 C392.487956,2918.43197 392.78418,2918.53223 393.166992,2918.53223 Z M393.166992,2924.17871 C393.54069,2924.17871 393.832357,2924.07503 394.041992,2923.86768 C394.251628,2923.66032 394.356445,2923.37663 394.356445,2923.0166 C394.356445,2922.6429 394.252767,2922.35579 394.04541,2922.15527 C393.838053,2921.95475 393.545247,2921.85449 393.166992,2921.85449 C392.775065,2921.85449 392.476562,2921.95247 392.271484,2922.14844 C392.066406,2922.3444 391.963867,2922.63379 391.963867,2923.0166 C391.963867,2923.38574 392.068685,2923.67171 392.27832,2923.87451 C392.487956,2924.07731 392.78418,2924.17871 393.166992,2924.17871 Z M400.939453,2923.99414 L400.939453,2914 L399.203125,2914 L395.983398,2916.56348 L397.001953,2917.83496 L398.150391,2916.91211 C398.287109,2916.80273 398.530924,2916.57259 398.881836,2916.22168 L398.881836,2916.22168 L398.847656,2917.26074 L398.827148,2918.21094 L398.827148,2923.99414 L400.939453,2923.99414 Z",
    id: "ImajBoyutu-Orjinal"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOriginal);
export default __webpack_public_path__ + "static/media/Original.45f05983b3f8d149bec6979d908be41d.svg";
export { ForwardRef as ReactComponent };